/**
 * Drawer Component
 */

class DrawerMenuItem {
    constructor(element) {
        this.element = element;
        this.toggleBtn = element.querySelector('.no-drawer__menu-link');
        this.submenu = element.querySelector('.no-drawer__submenu');
        this.isOpen = false;

        if (this.toggleBtn && this.submenu) {
            this.init();
        }
    }

    init() {
        this.updateAriaAttributes();
        this.toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle();
        });
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            const siblings = Array.from(this.element.parentElement.children);
            siblings.forEach(item => {
                if (item !== this.element) {
                    const menuItem = item.drawerMenuItemInstance;
                    if (menuItem && menuItem.isOpen) {
                        menuItem.close();
                    }
                }
            });
            this.open();
        }
    }

    open() {
        if (this.isOpen) return;

        this.isOpen = true;
        this.element.classList.add('is-open');
        this.toggleBtn.setAttribute('aria-expanded', 'true');
        this.updateAriaAttributes();

        if (this.toggleBtn) {
            this.toggleBtn.style.color = 'var(--clr-primary-main)';
            this.toggleBtn.style.opacity = '1';
        }

        const submenuHeight = this.submenu.scrollHeight;
        this.submenu.style.maxHeight = submenuHeight + 'px';
    }

    close() {
        if (!this.isOpen) return;

        this.isOpen = false;
        this.element.classList.remove('is-open');
        this.toggleBtn.setAttribute('aria-expanded', 'false');
        this.updateAriaAttributes();

        if (this.toggleBtn) {
            this.toggleBtn.style.color = '';
            this.toggleBtn.style.opacity = '';
        }

        this.submenu.style.maxHeight = '0px';
    }

    updateAriaAttributes() {
        if (this.toggleBtn) {
            this.toggleBtn.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
        }
        if (this.submenu) {
            this.submenu.setAttribute('aria-hidden', this.isOpen ? 'false' : 'true');
        }
    }
}

export class Drawer {
    constructor() {
        this.container = document.getElementById('main-drawer');
        
        if (!this.container) {
            console.warn('Drawer: Container element not found');
            return;
        }

        this.menuItems = [];
        this.resizeTimeout = null;
        
        // 전역 인스턴스 설정
        window.drawerInstance = this;
        
        this.init();
    }

    init() {
        this.initMenuItems();
        this.initResizeHandler();
    }

    initMenuItems() {
        const menuItemElements = this.container.querySelectorAll('[data-menu-item].has-submenu');
        
        menuItemElements.forEach((element) => {
            const menuItem = new DrawerMenuItem(element);
            element.drawerMenuItemInstance = menuItem;
            this.menuItems.push(menuItem);
        });
    }

    initResizeHandler() {
        // 초기 체크
        this.handleResize();
        
        // resize 이벤트 리스너 추가 (debounce 적용)
        window.addEventListener('resize', () => {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            
            this.resizeTimeout = setTimeout(() => {
                this.handleResize();
            }, 150);
        });
    }

    handleResize() {
        const windowWidth = window.innerWidth;
        
        // 1024px보다 큰 화면에서 drawer가 열려있으면 닫기
        if (windowWidth > 1024 && this.container.classList.contains('is-open')) {
            this.closeDrawer();
        }
    }

    closeDrawer() {
        // 모든 서브메뉴 닫기
        this.closeAllSubmenus();
        
        // body 스타일 복원
        document.body.classList.remove('--hidden');
        document.body.style.overflow = '';
        
        // drawer 닫기 (GSAP 애니메이션)
        if (typeof gsap !== 'undefined') {
            gsap.to(this.container, {
                y: '-100%',
                opacity: 0,
                duration: 0.3,
                ease: 'power2.in',
                onComplete: () => {
                    this.container.classList.remove('is-open');
                    this.container.style.visibility = 'hidden';
                    this.container.style.pointerEvents = 'none';
                }
            });
        } else {
            // GSAP이 없으면 즉시 닫기
            this.container.classList.remove('is-open');
            this.container.style.visibility = 'hidden';
            this.container.style.pointerEvents = 'none';
            this.container.style.transform = 'translateY(-100%)';
            this.container.style.opacity = '0';
        }
    }

    closeAllSubmenus() {
        this.menuItems.forEach(item => {
            if (item.isOpen) {
                item.close();
            }
        });
    }
}

